import { useState } from 'react';
import {
  getAutoCompleteFilter,
  useGetVendorsSelectInfiniteList,
} from '@sib/api';
import { DEFAULT_STALE_TIME } from '@sib/api/constants';
import { ComboboxAvatarItemOption } from '@sib/ui';
import { useAutocompleteProps, useDebouncedValue } from '@sib/utils';

export interface UseVendorsAutocompletePropsOptions {
  additionalFields?: ComboboxAvatarItemOption[];
  queryKey?: string[];
}

export const useVendorsAutocompleteProps = ({
  additionalFields,
  queryKey,
}: UseVendorsAutocompletePropsOptions = {}) => {
  const [filter, setFilter] = useState('');
  const debouncedFilter = useDebouncedValue(filter);
  const apiFilter = getAutoCompleteFilter({ searchTerm: debouncedFilter });

  const params = useGetVendorsSelectInfiniteList(apiFilter, {
    staleTime: DEFAULT_STALE_TIME,
    queryKey,
  });

  return useAutocompleteProps({
    params,
    filter,
    setFilter,
    optionsMapper: vendor => ({
      label: vendor.name,
      value: vendor.id,
    }),
    additionalFields,
  });
};
